import React, { FunctionComponent } from 'react';
import { PageStatus } from '../../../types/__generated__';

import PlaceholderBar from '../PlaceholderBar/PlaceholderBar';
import BenefactorListItem from './BenefactorListItem';

type BenefactorListItemSkeletonProps = {
  animated?: boolean;
};

const BenefactorListItemSkeleton: FunctionComponent<BenefactorListItemSkeletonProps> = ({
  animated,
}) => {
  return (
    <BenefactorListItem
      title={
        <PlaceholderBar
          width="50%"
          colour="nobel"
          marginBottom="28px"
          animated={animated}
        />
      }
      image=""
      currencyCode=""
      amount={0}
      supporterCount={0}
      url={undefined}
      pageStatus={PageStatus.Active}
      totaliserValue={null}
    />
  );
};

export default BenefactorListItemSkeleton;
